import React, { useContext, useEffect, useState } from "react";
import MessageErreur from "../../../Design/Messages/MessageErreur";
import LigneDemande from "./LigneDemande";
import { AdpxContext } from "../../../Data/AdpxContext";
import { pluriel } from "../../../functions/Formatter";

export default function ListeDemandesNonPlannifies({ style, onClickDemande }) {
  //NES gestion du contexte
  const { getAdpxDemandesNonplannifie, jours } = useContext(AdpxContext);

  //NES gestion du state
  const [liste, setListe] = useState([]);
  const [messageErreur, setMessageErreur] = useState();
  const [error, setError] = useState();

  useEffect(() => {
    getAdpxDemandesNonplannifie().then((reponse) => {
      if (reponse.code === "OK") {
        setListe(reponse.data);
      } else {
        setError(reponse.error);
        setMessageErreur(reponse.messageErreur);
      }
    });
    // eslint-disable-next-line
  }, [jours]);

  return (
    <div style={style}>
      <h3 style={{ color: "#205A71" }}>Demandes non plannifiées</h3>
      <p className="SousTitre">
        {pluriel(liste.length, "demande", "demandes", "F")}
      </p>
      <div style={{ marginTop: "10px" }}>
        <MessageErreur message={messageErreur} error={error} />
        {liste.map((demande) => (
          <LigneDemande demande={demande} onClickDemande={onClickDemande} />
        ))}
      </div>
    </div>
  );
}
